module.exports = __webpack_public_path__ + "static/media/Reports-selected-icon.3292f656.svg";